const trustItems = [
  { icon: "ri-shopping-bag-3-line", text: "Более 50,000 заказов через Spreadsheet" },
  { icon: "ri-shield-check-line", text: "Проверенные китайские поставщики" },
  { icon: "ri-money-dollar-circle-line", text: "Без скрытых комиссий" },
  { icon: "ri-file-list-line", text: "Полный контроль через таблицу" },
];

export default function TrustBar() {
  return (
    <section className="bg-background-100 border-b border-background-200">
      <div className="w-full px-4 md:px-8 py-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8 max-w-6xl mx-auto">
          {trustItems.map((item) => (
            <div key={item.text} className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 shrink-0">
                <i className={`${item.icon} text-lg`} />
              </div>
              <span className="text-sm md:text-base text-foreground-800 font-medium leading-snug">
                {item.text}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}